// Copyright ©️ 2026 eVolve MEP, LLC

import { ActionIcon } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

type Props = {
  onClick: () => void;
  direction: 'left' | 'right';
};

export const NavArrowActionIcon = ({ onClick, direction }: Props) => (
  <ActionIcon c="gray" onClick={onClick} p="lg" style={{ '--ai-hover': 'var(--mantine-color-gray-1)' }}>
    <EvolveIcon icon={direction === 'right' ? 'ArrowRight' : 'ArrowLeft'} size="sm" />
  </ActionIcon>
);
